<div class="page-footer" [ngClass]="isDashboard ? '' : 'upper-margin'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 page-logo logo">
        <div class="footerlogo">
          <a href="/Home/Index" routerLink="/dashboard"
            ><img src="assets/images/PIQET NewLogo_Footer.png" alt="Piqet"
          /></a>
        </div>
      </div>
    </div>
    <div class="bottomfooters">
      <div class="row">
        <div class="col-sm-10 col-md-10 strategies-text">
          <a href="https://www.lifecycles.com.au/" target="_blank"
            ><span class="lifecycles-text"
              ><i class="fa fa-copyright" aria-hidden="true"></i>&nbsp;Life Cycle Strategies Pty.
              Ltd. {{ currentYear }}</span
            ></a
          >| <a title="{{ appVersion }}">Release: v5.1</a> |
          <a href="mailto:info@piqet.com" style="color: #fff">info@piqet.com</a> |
          <span id="phone-link">+61 (03) 9417 1190</span> |
          <span id="linkedIn"
            ><a target="_blank" href="https://www.linkedin.com/company/90451316/">LinkedIn</a></span
          >
        </div>
      </div>
    </div>
  </div>
  <div
    class="scroll-to-top"
    style="display: block"
    [ngClass]="{ 'show-scroll': showScroll }"
    (click)="scrollToTop()"
  >
    <i class="fa fa-chevron-up"></i>
  </div>
</div>
